import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Tabs } from "antd";
import { OrganizationTabs } from "../../utils/constants";
import { useSearchParams } from "react-router-dom";
import "./index.css";

const Organization = () => {
  const { organizationData } = useSelector((state) => state?.organization);
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const sectionFromUrl = searchParams.get("section");

  const [activeTabKey, setActiveTabKey] = React.useState(
    tabFromUrl || OrganizationTabs[0].name
  );

  useEffect(() => {
    if (tabFromUrl) {
      setActiveTabKey(tabFromUrl);
    }
  }, [tabFromUrl]);

  const handleTabChange = (key) => {
    setActiveTabKey(key);
  };

  return (
    <Tabs
      activeKey={activeTabKey}
      onChange={handleTabChange}
      items={OrganizationTabs.map((item) => {
        if (organizationData?.isSTCapacitySet && item?.isCapacityDependent)
          return null;
        return {
          key: item.name,
          label: (
            <span>
              {React.cloneElement(item.icon, {
                isActive: item.name === activeTabKey,
              })}{" "}
              {item.name}
            </span>
          ),
          children: React.cloneElement(item.component, {
            activeSection: sectionFromUrl
          }),
        };
      })}
    />
  );
};

export default Organization;
